var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.Gzxcx),
      expression: "Gzxcx"
    }]
  }, [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "float": "left",
      "margin": "-40px 0 0 40px",
      "font-weight": "600"
    }
  }, [_vm._v("雇主险出险")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "750px",
      "background-color": "white",
      "margin": "75px 40px 0 40px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "2%"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "40px"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('span', [_vm._v("组织架构")]), _vm._v(" "), _c('el-cascader', {
    staticStyle: {
      "margin-left": "10px",
      "width": "300px"
    },
    attrs: {
      "clearable": "",
      "collapse-tags": "",
      "props": _vm.props
    },
    model: {
      value: (_vm.condition.organize_ids),
      callback: function($$v) {
        _vm.$set(_vm.condition, "organize_ids", $$v)
      },
      expression: "condition.organize_ids"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-left": "10px"
    }
  }, [_c('span', [_vm._v("岗位 ")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "margin-left": "10px",
      "width": "150px"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.condition.post_id),
      callback: function($$v) {
        _vm.$set(_vm.condition, "post_id", $$v)
      },
      expression: "condition.post_id"
    }
  }, _vm._l((_vm.postList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.post_name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-left": "10px"
    }
  }, [_c('span', [_vm._v("姓名 ")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "margin-left": "10px",
      "width": "150px"
    },
    attrs: {
      "placeholder": "请输入姓名"
    },
    model: {
      value: (_vm.condition.staff_name),
      callback: function($$v) {
        _vm.$set(_vm.condition, "staff_name", $$v)
      },
      expression: "condition.staff_name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-left": "10px"
    }
  }, [_c('span', [_vm._v("保单号 ")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "margin-left": "10px",
      "width": "150px"
    },
    attrs: {
      "placeholder": "请输入保单号"
    },
    model: {
      value: (_vm.condition.policy_no),
      callback: function($$v) {
        _vm.$set(_vm.condition, "policy_no", $$v)
      },
      expression: "condition.policy_no"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('span', [_vm._v("出险时间")]), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "margin-left": "10px",
      "width": "160px"
    },
    attrs: {
      "value-format": "yyyy-MM-dd",
      "type": "date",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.condition.danger_dete),
      callback: function($$v) {
        _vm.$set(_vm.condition, "danger_dete", $$v)
      },
      expression: "condition.danger_dete"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-left": "10px"
    }
  }, [_c('span', [_vm._v("出险状态 ")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "margin-left": "10px",
      "width": "150px"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.condition.state),
      callback: function($$v) {
        _vm.$set(_vm.condition, "state", $$v)
      },
      expression: "condition.state"
    }
  }, _vm._l((_vm.cxztList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-left": "50px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "goon"
    },
    on: {
      "click": _vm.Find
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "goon"
    }
  }, [_vm._v("导入")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-left": "10px"
    }
  }, [_c('download-excel', {
    staticClass: "export-excel-wrapper",
    staticStyle: {
      "top": "100px"
    },
    attrs: {
      "fields": _vm.download_excel,
      "title": "雇主险出险人员",
      "name": "雇主险出险人员.xls",
      "fetch": _vm.ExportForm
    }
  }, [_c('el-button', {
    attrs: {
      "type": "goon"
    }
  }, [_vm._v("导出")])], 1)], 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "goon"
    },
    on: {
      "click": function($event) {
        return _vm.Del()
      }
    }
  }, [_vm._v("删除")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "addbtn"
    },
    on: {
      "click": function($event) {
        return _vm.add()
      }
    }
  }, [_vm._v("新增")])], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "1% 3% 0 3%"
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "header-cell-style": {
        background: '#F0F0F0',
        color: '#000000'
      },
      "row-class-name": _vm.tableRowClassName,
      "data": _vm.tableData,
      "tooltip-effect": "dark",
      "height": "540"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "45"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "序号",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope_1) {
        return [_vm._v(_vm._s(scope_1.$index + 1))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "组织架构",
      "width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t  \t" + _vm._s(_vm.$globals.group_name + "/" + scope.row.range) + "\n\t\t\t  ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "staff_name",
      "align": "center",
      "label": "姓名",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "staff_gender",
      "align": "center",
      "label": "性别",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "staff_card",
      "align": "center",
      "label": "身份证号",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "staff_telephone",
      "align": "center",
      "label": "手机号",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "post_name",
      "align": "center",
      "label": "岗位",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "danger_dete",
      "align": "center",
      "label": "出险时间",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "policy_no",
      "align": "center",
      "label": "保单号",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "close_date",
      "align": "center",
      "label": "结案日期",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "states",
      "align": "center",
      "label": "出险状态",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\n              " + _vm._s(scope.row.settlement_status == '0' ? "未理赔" : (scope.row.settlement_status == '1' ? "已理赔" : "已撤案")) + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "操作",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          attrs: {
            "src": require("../../../assets/详情.png")
          },
          on: {
            "click": function($event) {
              return _vm.xiangqing(scope.row)
            }
          }
        }), _vm._v(" "), _c('img', {
          attrs: {
            "src": require("../../../assets/编辑.png")
          },
          on: {
            "click": function($event) {
              return _vm.Edit(scope.row)
            }
          }
        }), _vm._v(" "), _c('img', {
          attrs: {
            "src": require("../../../assets/删除.png")
          },
          on: {
            "click": function($event) {
              return _vm.Del(scope.row.id)
            }
          }
        })]
      }
    }])
  })], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "10px",
      "text-align": "center"
    }
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "page-size": _vm.page_size,
      "layout": " prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)])]), _vm._v(" "), _c('add', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showadd),
      expression: "showadd"
    }],
    ref: "adds",
    attrs: {
      "staffList": _vm.staffList
    }
  }), _vm._v(" "), _c('edit', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showedit),
      expression: "showedit"
    }],
    ref: "edits"
  })], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7feec2be","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bxgl/GzxCx/Gzxcx.vue
// module id = null
// module chunks = 